import classnames from 'classnames';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import Input from 'v2/form/Input/Input';
import Select from 'v2/form/Select/Select';
import TextArea from 'v2/form/TextArea/TextArea';
import { formatDataFileType } from 'v2/utils/textFormat';
import DataFileBox from '../DataFileBox/DataFileBox';
import { DataFileEntity, DataFileForm, FileData } from '../models';
import styles from './addNewFileForm.module.scss';

const FILE_TYPES: DataFileEntity['file_type'][] = [
  'Data_Dictionary',
  'Product_Overview',
  'Company_Overview',
  'Sample_Data',
  'Whitepaper',
  'Other',
];

const FILE_TYPE_OPTIONS = FILE_TYPES.map((fileType) => ({
  label: formatDataFileType(fileType),
  value: fileType,
}));

interface AddNewFileFormProps {
  fileData: FileData;
  register: UseFormRegister<DataFileForm>;
  errors: FieldErrors<DataFileForm>;
  onDrop: (acceptedFiles: File[]) => void;
}

const AddNewFileForm = ({
  fileData,
  register,
  errors,
  onDrop,
}: AddNewFileFormProps) => {
  const { getInputProps, getRootProps } = useDropzone({
    multiple: false,
    noKeyboard: true,
    onDrop,
  });

  return (
    <>
      <div
        className={classnames(
          'form-group',
          styles.fileContainer,
          styles.fileContainerRedesign
        )}
      >
        <DataFileBox fileData={fileData} />
        <button
          {...getRootProps()}
          className="btn btn-primary-outline"
          type="button"
        >
          Change File
          <input {...getInputProps()} />
        </button>
      </div>
      <div className="form-group">
        <Input
          label="Name"
          type="text"
          register={register('name', { required: true })}
          error={errors?.name?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
        />
      </div>
      <div className="form-group">
        <Select
          label="File Type"
          register={register('file_type', { required: true })}
          error={errors?.file_type?.message}
          required={true}
          options={[{ label: '', value: '' }, ...FILE_TYPE_OPTIONS]}
        />
      </div>
      <div className="form-group">
        <TextArea
          label="Description"
          register={register('description', { required: true })}
          error={errors?.description?.message}
          rows={8}
          autoComplete="off"
          required={true}
        />
      </div>
    </>
  );
};

export default AddNewFileForm;
